import { render, staticRenderFns } from "./StudyCategoryPanel.vue?vue&type=template&id=bbe8366e&scoped=true&lang=pug&"
import script from "./StudyCategoryPanel.vue?vue&type=script&lang=ts&"
export * from "./StudyCategoryPanel.vue?vue&type=script&lang=ts&"
import style0 from "./StudyCategoryPanel.vue?vue&type=style&index=0&id=bbe8366e&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbe8366e",
  null
  
)

export default component.exports